export enum EShippingListEntryStatus {
    DuplicateItemsPriceInvalid = -1,
    Invalid = 0,
    Valid = 1,
    ValidWithDifferentPrices = 2
}

export enum EShippingListDataFilter {
    All = 'Show all',
    PriceDifferences = 'Price mismatch',
    QuantityDifferences = 'Uploaded qty greater than open qty'
}

export interface IShippingListEntry {
    itemcode: string;
    quantity: number;
    price: number;
    poPrice: number;
    totalAllocated: number;
    isValid: boolean;
    status: EShippingListEntryStatus;
}

export interface IShippingListEntryFromSql {
    Id: number;
    ItemCode: string;
    Quantity: string;
    TotalAllocated: string;
    Price: string;
    POPrice: string;
    Status: 2 | 1 | 0 | -1;
}

export interface IShippingListUpload {
    id: number;
    data: IShippingListEntryFromSql[];
}

export interface IShippingListEntryValidation {
    isValid: boolean;
    quantityInvalid: boolean;
    priceDifferent: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/shippingList.ts